import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getServiceInvoices,
  getServiceInvoiceById,
  createServiceInvoice,
  updateServiceInvoice,
  deleteServiceInvoice,
} from "api/serviceInvoiceApi"

export const SERVICE_INVOICE_QUERY_KEY = "service-invoices"

// -------------------- FETCH PAGINATED --------------------
export const useServiceInvoices = (params = {}, enabled = true) => {
  return usePaginatedResource(
    SERVICE_INVOICE_QUERY_KEY,
    getServiceInvoices,
    params,
    enabled
  )
}

// -------------------- FETCH SINGLE ITEM --------------------
export const useServiceInvoice = (id, enabled = true) => {
  return useResourceItem(
    SERVICE_INVOICE_QUERY_KEY,
    getServiceInvoiceById,
    id,
    enabled
  )
}

// -------------------- CREATE --------------------
export const useCreateServiceInvoice = () => {
  return useCreateResource(createServiceInvoice, SERVICE_INVOICE_QUERY_KEY)
}

// -------------------- EDIT --------------------
export const useEditServiceInvoice = () => {
  return useEditResource(updateServiceInvoice, SERVICE_INVOICE_QUERY_KEY)
}

// -------------------- DELETE (Soft Delete) --------------------
export const useDeleteServiceInvoice = () => {
  return useDeleteResource(deleteServiceInvoice, SERVICE_INVOICE_QUERY_KEY)
}
